import { IElementCategory } from '../../models/element-categories.model';
import { airHandlingUnit } from './air-handling-unit';
import { heating } from './heating';
import { cooling } from './cooling';
import { maintenance } from './maintenance';

// Will appear in order in UI
export const installationCategories: IElementCategory[] = [
  airHandlingUnit,
  heating,
  cooling,
  maintenance,
];
